import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../lib/route-guard.js';

export const Route = createFileRoute('/manufacturing')({
  component: () => <RouteGuard route="/manufacturing" />,
});
